import {
  buildDocumentsTree,
  flattenDocumentTree,
} from '@cd3p/core/utils/documents';
import { State } from 'modules';
import { createSelector } from 'reselect';

export const helpCenter = (state: State) => state.helpCenter;
export const helpCenterItems = (state: State) => state.helpCenter.items;
export const helpCenterItemsLoading = (state: State) =>
  state.helpCenter.loadHelpCenterDocumentsPending;
export const helpCenterItemsLoaded = (state: State) =>
  state.helpCenter.itemsLoaded;
export const helpCenterItemsTree = (state: State) =>
  buildDocumentsTree(state.helpCenter.items);
export const helpCenterSortedItems = createSelector(
  helpCenterItemsTree,
  itemsTree => {
    return flattenDocumentTree(itemsTree);
  },
);
export const fetchHelpCenterDocumentPending = (state: State) =>
  state.helpCenter.fetchHelpCenterDocumentPending;
